import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { USAePay, USAePayPayload } from "src/app/models/USAePay";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-usa-e-pay',
    templateUrl: './usa-e-pay.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutUsaEPayComponent implements OnInit {
    @Input() public usaEPay: USAePay;
    
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }

    ngOnInit(): void {
    }

    public submit(event: USAePayPayload): void {
        this.emitComplete.emit(event);
    }
}